import axios from "../utils/axios.wrapper";

export const getManufacturingOrders = async () => {
  const { data } = await axios.get("/ManufacturingOrder");
  return data.items || data;
};

export const getManufacturingOrderById = async (id) => {
  const { data } = await axios.get(`/manufacturingOrder/${id}`);
  return data;
};

export const createManufacturingOrder = async (order) => {
  const { data } = await axios.post("/manufacturingOrder/create", order);
  return data;
};

// export const updateManufacturingOrder = async (id, order) => {
//   const { data } = await axios.put(`/manufacturingOrder/${id}`, order);
//   return data;
// };

export const updateManufacturingOrder = async (id, order) => {
  const { data } = await axios.put(`/manufacturingOrder/${id}`, order);
  return data; // { jobId, orderId, status, message }
};

export const deleteManufacturingOrder = async (id) => {
  const { data } = await axios.delete(`/manufacturingOrder/${id}`);
  return data;
};

export const cancelManufacturingOrder = async (id) => {
  const { data } = await axios.delete(`/manufacturingOrder/cancel/${id}`);
  return data;
};

export const manufacturingOrderService = {
  getManufacturingOrders,
  getManufacturingOrderById,
  createManufacturingOrder,
  updateManufacturingOrder,
  deleteManufacturingOrder,
  cancelManufacturingOrder,
};
